<style src="../assets/css/homepagearticle.css" scoped></style>


<template>
<main class="page">
  <!-- HERO -->
  <section class="hero">
    <div>
      <h1>Le blog</h1>
      <p>
        Chaque semaine, un article pour aider à mieux comprendre l’adoption, préparer l’arrivée d’un animal,
        et améliorer la visibilité du projet via le <span class="hl">référencement</span>.
      </p>
    </div>
  </section>

  <!-- FEATURED -->
  <a class="featured" href="article.html">
    <div class="featuredThumb">
      <div class="badge"><span class="dot"></span> Conseils adoption</div>
    </div>
    <div class="featuredBody">
      <div>
        <div class="featuredTitle">Adopter un chien : 7 questions à se poser avant de se lancer</div>
        <p class="featuredExcerpt">
          Un guide clair pour faire le bon choix et préparer l’arrivée de votre futur compagnon,
          tout en respectant le rythme du refuge.
        </p>
      </div>

      <div class="featuredMeta">
        <span class="pill">⏱ 6 min</span>
        <span class="pill">📅 14 janv. 2026</span>
        <span class="pill">Conseils</span>
      </div>
    </div>
  </a>

  <!-- TOOLBAR -->
  <div class="toolbar">
    <div class="search">
      <span class="icon" aria-hidden="true"></span>
      <input type="search" placeholder="Rechercher un article (adoption, chat, chien, refuge...)" />
    </div>

    <div class="filters" aria-label="Filtres">
      <a class="chip active" href="#">Tous</a>
      <a class="chip" href="#">Conseils</a>
      <a class="chip" href="#">Guides</a>
      <a class="chip" href="#">Refuges</a>
      <a class="chip" href="#">Éducation</a>
    </div>
  </div>

  <!-- GRID -->
  <section class="grid" aria-label="Liste des articles">
    <a class="card" href="article.html">
      <div class="thumb">
        <div class="badge"><span class="dot"></span> Conseils</div>
      </div>
      <div class="body">
        <div class="title">Adopter un chat : les erreurs fréquentes à éviter</div>
        <p class="excerpt">Les réflexes simples qui évitent les abandons et facilitent l’intégration.</p>
        <div class="meta"><span>5 min</span><span>11 janv. 2026</span></div>
      </div>
    </a>

    <a class="card" href="article.html">
      <div class="thumb">
        <div class="badge"><span class="dot"></span> Guide</div>
      </div>
      <div class="body">
        <div class="title">Préparer son logement avant l’arrivée d’un animal</div>
        <p class="excerpt">Checklist rapide : sécurité, coins repos, accessoires, routine.</p>
        <div class="meta"><span>4 min</span><span>04 janv. 2026</span></div>
      </div>
    </a>

    <a class="card" href="article.html">
      <div class="thumb">
        <div class="badge"><span class="dot"></span> Éducation</div>
      </div>
      <div class="body">
        <div class="title">Comprendre la période d’adaptation après adoption</div>
        <p class="excerpt">Ce qui est normal au début, comment réagir, et quoi éviter.</p>
        <div class="meta"><span>6 min</span><span>28 déc. 2025</span></div>
      </div>
    </a>

    <a class="card" href="article.html">
      <div class="thumb">
        <div class="badge"><span class="dot"></span> Refuges</div>
      </div>
      <div class="body">
        <div class="title">Comment fonctionne un refuge partenaire sur Asso-Refuge ?</div>
        <p class="excerpt">Site personnalisé, données centralisées, et visibilité double pour les animaux.</p>
        <div class="meta"><span>5 min</span><span>21 déc. 2025</span></div>
      </div>
    </a>

    <a class="card" href="article.html">
      <div class="thumb">
        <div class="badge"><span class="dot"></span> Conseils</div>
      </div>
      <div class="body">
        <div class="title">Adoption responsable : questions à poser au refuge</div>
        <p class="excerpt">Tempérament, compatibilités, besoins : les points clés.</p>
        <div class="meta"><span>4 min</span><span>14 déc. 2025</span></div>
      </div>
    </a>

    <a class="card" href="article.html">
      <div class="thumb">
        <div class="badge"><span class="dot"></span> Guide</div>
      </div>
      <div class="body">
        <div class="title">Chien ou chat : quel compagnon selon votre mode de vie ?</div>
        <p class="excerpt">Une approche simple pour éviter les mauvais match.</p>
        <div class="meta"><span>6 min</span><span>07 déc. 2025</span></div>
      </div>
    </a>

    <a class="card" href="article.html">
      <div class="thumb">
        <div class="badge"><span class="dot"></span> Éducation</div>
      </div>
      <div class="body">
        <div class="title">Gérer la solitude : éviter l’anxiété de séparation</div>
        <p class="excerpt">Étapes progressives et erreurs fréquentes à éviter.</p>
        <div class="meta"><span>7 min</span><span>30 nov. 2025</span></div>
      </div>
    </a>

    <a class="card" href="article.html">
      <div class="thumb">
        <div class="badge"><span class="dot"></span> Refuges</div>
      </div>
      <div class="body">
        <div class="title">Pourquoi des sites gratuits pour les refuges ?</div>
        <p class="excerpt">Le but : libérer du temps aux équipes et booster l’adoption.</p>
        <div class="meta"><span>3 min</span><span>23 nov. 2025</span></div>
      </div>
    </a>
  </section>
</main>

<!-- FOOTER (HTML identique à ton footer actuel) -->
<footer class="footer">
  <div class="footer-inner">

    <div class="footer-ctaCard">
      <div class="footer-ctaLeft">
        <div class="footer-ctaTitle">
          Vous êtes un refuge ?
          <span class="footer-hl">On crée votre site gratuitement.</span>
        </div>
        <p class="footer-ctaText">
          <strong>Hébergement inclus</strong>, <strong>sans publicité</strong>, et vos animaux gagnent une
          <strong>double visibilité</strong> (site du refuge + Asso-Refuge).
        </p>

        <div class="footer-badges" aria-label="Engagements du projet">
          <span class="footer-badge"><span class="dot"></span> 100% gratuit</span>
          <span class="footer-badge"><span class="dot"></span> Hébergement inclus</span>
          <span class="footer-badge"><span class="dot"></span> Sans publicité</span>
        </div>
      </div>

      <div class="footer-ctaRight">
        <RouterLink to="/contact" class="nav-link linkBtn primary">Devenir refuge partenaire</RouterLink>
        <RouterLink to="/contact" class="nav-link footer-btn ghost">Nous contacter</RouterLink>
      </div>
    </div>

    <div class="footer-grid">
      <div class="footer-brand">
        <div class="footer-logo">
          <span class="dot"></span>
          <span>Asso-Refuge</span>
        </div>
        <p class="footer-desc">
          Plateforme indépendante pour centraliser les animaux à l’adoption et offrir aux refuges
          un site moderne <span class="footer-hl">gratuit</span> (hébergement inclus, sans pub).
        </p>
      </div>

      <div class="footer-col">
        <h4>Découvrir</h4>
        <ul>
        <li>  <RouterLink to="/animaux" >Animaux à l’adoption</RouterLink></li>
        <li> <RouterLink to="/refuges" >Refuges partenaires</RouterLink></li>
        <li><RouterLink to="/projet" >Le projet</RouterLink></li>
        <li> <RouterLink to="/contact" >Sponsors</RouterLink></li>

        </ul>
      </div>

      <div class="footer-col">
        <h4>Partenariats</h4>
        <ul>
          <li>
          <RouterLink to="/contact" class="nav-link highlight">Devenir refuge partenaire</RouterLink>
          </li>
          <li>  <RouterLink to="/contact" >Devenir sponsor</RouterLink></li>
          <li>
            <RouterLink to="/contact" >Contact</RouterLink>
          </li>
        </ul>
      </div>

      <div class="footer-col">
        <h4>Contact</h4>
        <ul>
          <li><a href="mailto:lesrefuges.animalier@gmail.com ">lesrefuges.animalier@gmail.com </a></li>
          <li> <RouterLink to="/rgpd" class="nav-link">Mentions légales & RGPD</RouterLink></li>

         
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      <p>© 2026 Asso-Refuge — Projet indépendant, sans publicité.</p>
        <div class="footer-bottomLinks">
       <RouterLink to="/rgpd" class="nav-link">Mentions légales & RGPD</RouterLink>
        <span class="sep">•</span>
        <RouterLink to="/contact" class="nav-link ">Contact</RouterLink>
      </div>
    </div>

  </div>
</footer>

<!-- BOTTOM NAV (mobile) -->
<nav class="bottom-nav" aria-label="Navigation mobile">
  <a href="#" class="active">
    <span class="ico" aria-hidden="true"></span>
    Blog
  </a>
  <a href="#">
    <span class="ico" aria-hidden="true"></span>
    Animaux
  </a>
  <a href="#">
    <span class="ico" aria-hidden="true"></span>
    Refuges
  </a>
  <a href="#">
    <span class="ico" aria-hidden="true"></span>
    Projet
  </a>
  <a href="#">
    <span class="ico" aria-hidden="true"></span>
    Contact
  </a>
</nav>


</template>